import React from 'react';

import { motion } from 'framer-motion';

const transition = {
  duration: 0.75,
  delay: 0,
  ease: 'easeInOut',
};

const variant = {
  hidden: {
    pathLength: 0,
  },
  visible: {
    pathLength: 1,
  },
};

const animation = {
  initial: 'hidden',
  whileInView: 'visible',
  viewport: { once: true },
  stroke: '#00A3FF',
  variants: variant,
  strokeWidth: 1,
  transition: {
    default: transition,
  },
  fill: 'none',
};

export function Triangle(props) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 100">
      {props.isStatic ? (
        <path
          id="bottom"
          className="z-[155]"
          {...animation}
          d="M 20 50 A 80 20 0 1 1 180 50"
          fill="transparent"
          stroke="transparent"
          strokeWidth="3"
        />
      ) : (
        <motion.path
          id="bottom"
          className="z-[155]"
          {...animation}
          d="M 20 50 A 80 20 0 1 1 180 50"
          fill="transparent"
          stroke="transparent"
          strokeWidth="3"
        />
      )}
      <path
        id="top"
        {...animation}
        className="shadow-top-line z-[7]"
        d="M 180 50 A 80 20 0 1 1 20 50"
        fill="transparent"
        stroke="#438E61"
        strokeWidth="3"
      />
    </svg>
  );
}

export function Blocker(props) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 150">
      <path
        className="relative z-[9] h-full min-h-[37.5rem]"
        d="M 20 40 A 80 20 0 1 1 180 40 L 180 110 A 80 20 0 1 0 20 110 Z"
        fill="black"
        stroke="transparent"
      />
      <path
        className="relative z-[1]"
        d="M 20 40 A 80 20 0 1 1 250 40"
        fill="black"
        stroke="transparent"
        strokeWidth="1"
      />
      {props.isStatic ? (
        <path className="" d="M 20 111 A 80 20 0 1 1 180 111" fill="transparent" stroke="#438E61" strokeWidth="3" />
      ) : (
        <motion.path
          {...animation}
          transition={{ duration: 0.75, delay: 0.75 }}
          className=""
          d="M 20 111 A 80 20 0 1 1 180 111"
          fill="transparent"
          stroke="#438E61"
          strokeWidth="3"
        />
      )}
      <line x1="20" y1="40" x2="20" y2="110" stroke="transparent" strokeWidth="1" />
      <line x1="180" y1="40" x2="180" y2="110" stroke="transparent" strokeWidth="1" />
    </svg>
  );
}


/*<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 150" width="200" height="150">
  <!-- Back body (z-index: 1) - Filled cylinder body -->
  <path d="M 20 40 A 80 20 0 1 1 180 40 L 180 110 A 80 20 0 1 0 20 110 Z" fill="lightgray" stroke="transparent" />

  <!-- Top ellipse (Back line, z-index: 2) -->
  <path d="M 20 40 A 80 20 0 1 1 180 40" fill="transparent" stroke="black" stroke-width="3" />

  <!-- Bottom ellipse (Front line, z-index: 3) -->
  <path d="M 20 110 A 80 20 0 1 1 180 110" fill="transparent" stroke="black" stroke-width="3" />

  <!-- Left side (vertical line, z-index: 4) -->
  <line x1="20" y1="40" x2="20" y2="110" stroke="black" stroke-width="3" />

  <!-- Right side (vertical line, z-index: 5) -->
  <line x1="180" y1="40" x2="180" y2="110" stroke="black" stroke-width="3" />

  <!-- Bottom "mirrored" arc (z-index: 6) -->
  <path d="M 20 110 A 80 20 0 1 0 180 110" fill="transparent" stroke="black" stroke-width="3" />
</svg>*/
